<template>
<div class='bodyer register'>
    <div class='container'>
        <div class='box-form'>
            <div class='row'>
                <div class='col-md-offset-7 col-md-5'>
                    <div class='box-tab register'>
                        <div class='top-tip'>专属通行证，玩转应答旗下游戏</div>
                        <ul class='nav nav-tabs'>
                            <li class='active' style="width: 100%">
                                <a data-toggle='tab' data-target='#by-mobile'>
                                    <span>
                                        <i class='icon iconfont icon-dianhua-copy-copy-copy-copy'></i>手机注册
                                    </span>
                                </a>
                            </li>
                            <!--<li>
                                <a data-toggle='tab' data-target='#by-email'>
                                    <span><i class='icon iconfont icon-youxiang'></i>邮箱注册</span>
                                </a>
                            </li>-->
                        </ul>
                        <div class='tab-content'>
                            <div class='tab-pane fade in active tab-form' id='by-mobile'>
                                <div class='form form-mobile'>
                                    <div class='form-group'>
                                        <input type='text' class='form-control' 
                                            v-model='by_mobile.mobile'
                                            placeholder='手机号码' pattern='^[0-9]{11}' required 
                                            data-error='手机号格式错误'>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='form-group'>
                                        <div class='input-group'>
                                            <input type='text' class='form-control'
                                                v-model='by_mobile.sms_code' pattern='^[0-9]{6}$'
                                                data-error='请输入6位数字验证码' 
                                                placeholder='验证码' required>
                                            <span class='input-group-btn'>
                                                <button class='btn btn-default' type='button'
                                                    @click='sendSms()' v-if='!this.forbid_sms'>
                                                    免费获取
                                                </button>
                                                <button class='btn btn-default' type='button'
                                                    disabled v-if='this.forbid_sms'>
                                                    {{forbid_sms}}s后重新发送
                                                </button>
                                            </span>
                                        </div>
                                        <div class='help-block with-errors'></div>
                                    </div>
                                    <div class='form-group'>
                                        <input type='password' class='form-control' 
                                            v-model='by_mobile.password'
                                            placeholder='密码' pattern='^[_A-z0-9]{6,12}' required 
                                            data-error='6-12位数字、字母或下划线'>
                                            <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='title'>
                                        实名及防沉迷信息填写
                                        <a data-toggle='tooltip' title="根据《网络游戏管理暂行办法》，网络游戏用户需使用有效身份证件进行实名注册。为保证流畅游戏体验，享受健康游戏生活，请应答游戏通行证用户尽快实名注册。保护未成年人身心健康，未满18岁的用户将受到防沉迷系统的限制，游戏过程，会提示您的累计在线时间：累计游戏时间超过3小时，游戏收益（经验，金钱）减半。累计游戏时间超过5小时，游戏收益为0。">为什么要填写</a>
                                    </div>
                                    <div class='form-group'>
                                        <input type='text' class='form-control' 
                                            v-model='by_mobile.truename'
                                            placeholder='真实姓名' maxlength='5' required 
                                            data-error='姓名不符合规范'>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='form-group'>
                                        <input type='text' class='form-control' 
                                            v-model='by_mobile.id_card'
                                            placeholder='身份证号' pattern='[0-9]{17}[\d|x]' 
                                            required 
                                            data-error='身份证号格式错误'>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                    <div class="checkbox">
                                        <label>
                                          <input type="checkbox" v-model='agree'><a href="/#/about/protocol" target="_blank">同意并阅读用户协议</a>
                                        </label>
                                    </div>
                                    <div class='form-group'>
                                        <button class='btn btn-warning btn-block' 
                                            @click='regByMobile()'>注册</button>
                                    </div>
                                </div>
                            </div>
                            <div class='tab-pane fade tab-form' id='by-email'>
                                <div class='form form-email'>
                                    <div class='form-group'>
                                        <input type='email' class='form-control' 
                                            v-model='by_email.email'
                                            placeholder='邮箱' required 
                                            data-error='邮箱格式错误'>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                    <!-- 
                                    <div class='form-group'>
                                        <div class='input-group'>
                                            <input type='text' class='form-control'
                                                v-model='by_email.email_code' pattern='^[0-9]{6}$'
                                                data-error='请输入6位数字验证码' 
                                                placeholder='验证码' required>
                                            <span class='input-group-btn'>
                                                <button class='btn btn-default' type='button'
                                                    @click='sendEmail()' v-if='!this.forbid_email'>
                                                    免费获取
                                                </button>
                                                <button class='btn btn-default' type='button'
                                                    disabled v-if='this.forbid_email'>
                                                    {{forbid_email}}s后重新发送
                                                </button>
                                            </span>
                                        </div>
                                        <div class='help-block with-errors'></div>
                                    </div> 
                                    -->
                                    <div class='form-group'>
                                        <input type='password' class='form-control' id='password'
                                            v-model='by_email.password'
                                            placeholder='密码' pattern='^[_A-z0-9]{6,12}' required 
                                            data-error='6-12位数字、字母或下划线'>
                                            <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='form-group'>
                                        <input type='password' class='form-control'
                                            data-match='#password'  
                                            placeholder='确认密码' pattern='^[_A-z0-9]{6,12}' required 
                                            data-error='密码不一致'>
                                            <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='title'>
                                        实名及防沉迷信息填写
                                        <a data-toggle='tooltip' title="根据《网络游戏管理暂行办法》，网络游戏用户需使用有效身份证件进行实名注册。为保证流畅游戏体验，享受健康游戏生活，请广大应答游戏通行证用户尽快实名注册。保护未成年人身心健康，未满18岁的用户将受到防沉迷系统的限制，游戏过程，会提示您的累计在线时间：累计游戏时间超过3小时，游戏收益（经验，金钱）减半。累计游戏时间超过5小时，游戏收益为0。">为什么要填写</a>
                                    </div>
                                    <div class='form-group'>
                                        <input type='text' class='form-control' 
                                            v-model='by_email.truename'
                                            placeholder='真实姓名' maxlength='5' required 
                                            data-error='姓名不符合规范'>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                    <div class='form-group'>
                                        <input type='text' class='form-control' 
                                            v-model='by_email.id_card'
                                            placeholder='身份证号' pattern='[0-9]{17}[\d|x]' 
                                            required 
                                            data-error='身份证号格式错误'>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                    <div class="checkbox">
                                        <label>
                                          <input type="checkbox" v-model='agree'><a href="/#/about/protocol" target="_blank">同意并阅读用户协议</a>
                                        </label>
                                    </div>
                                    <div class='form-group'>
                                        <button class='btn btn-warning btn-block' 
                                            @click='regByEmail()'>注册</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class='box-link'>
        <div class='container'>
            <me-link></me-link>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Notify from '@/common/Notify'
import Request from '@/common/Request'
import Common from '@/common/Common'
import Config from '@/common/Config'
import Format from '@/common/Format'
import ScrollReveal from 'scrollreveal'
import Link from '@/components/util/Link'
export default {
    data() {
        return {
            'forbid_sms' : false,
            'forbid_email' : false,
            'agree' : false,
            'by_mobile' : {
                'mobile' : '',
                'sms_code' : '',
                'password' : '',
                'truename' : '',
                'id_card' : '',
            },
            'by_email' : {
                'email' : '',
                'email_code' : '',
                'password' : '',
                'truename' : '',
                'id_card' : '',
            }
        }
    },
    components: {
        'me-link': Link
    },
    props: ['setUser'],
    methods: {
        //手机号注册
        regByMobile() {
            if($('.form-mobile').data('bs.validator').validate().hasErrors()){
                return false
            }
            if(!this.agree){
                Notify.error('请阅读并同意协议!')
                return false
            }
            var url = Request.createApi('/app/register-by-mobile')
            Request.post(url, this.by_mobile, res => {
                this.setUser(res.info)
                Notify.notice('恭喜您，注册成功！')
                Common.toUrl('/user')
                return true
            })
        },
        //邮箱注册
        regByEmail() {
            if($('.form-email').data('bs.validator').validate().hasErrors()){
                return false
            }
            if(!this.agree){
                Notify.error('请阅读并同意协议!')
                return false
            }
            var url = Request.createApi('/app/register-by-email')
            Request.post(url, this.by_email, res => {
                this.setUser(res.info)
                Notify.notice('恭喜您，注册成功！')
                Common.toUrl('/user')
                return true
            })
        },

        //验证码发送
        sendSms() {
            if(this.forbid_sms !== false){
                return true
            }
            if(!/[0-9]{11}/.test(this.by_mobile.mobile)){
                Notify.error('手机号格式错误!');
                return false;
            }

            var url = Request.createApi('/public/send-sms-code')
            var param = {
                'mobile' : this.by_mobile.mobile
            }
            Request.post(url, param, res => {
                Notify.success('验证码发送成功!');
                //冻结短信发送功能
                this.forbid_sms = 60;
                var loop = setInterval(() => {
                    this.forbid_sms--
                    if(this.forbid_sms < 1){
                        this.forbid_sms = false
                        clearInterval(loop)
                    }
                }, 1000)
            })   
        },

        //发送邮箱验证码
        sendEmail() {
            if(!/[_A-z0-9]{1,20}@\w+\.[com|cn]/.test(this.by_email.email)){
                Notify.error('邮箱格式错误!')
                return false
            }
            var url = Request.createApi('/public/send-email-code')
            var param = {
                'email' : this.by_email.email
            }
            Request.post(url, param, res => {
                Notify.success('验证码已发送!')
                this.forbid_email = 60
                var loop = setInterval(() => {
                    this.forbid_email--
                    if(this.forbid_email < 1){
                        this.forbid_email = false
                        clearInterval(loop)
                    }
                }, 1000)
            })
        }
    },
    mounted() {
        $(function () { 
            $("[data-toggle='tooltip']").tooltip(); 
            $('.form-mobile').validator()
            $('.form-email').validator()
        });
        var show = ScrollReveal({
            'origin' : 'bottom',
            'distance' : '200px',
            'duration' : 500,
        });

        show.reveal('.box-tab', {'origin' : 'right'})

        $('.c-link-class').each(function(k){
            show.reveal($(this), {
                delay: k*200 + 200
            })
        })
    },
    created() {
        window.scrollTo(0, 0)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/user/Register.vue